import { Inject, Injectable } from '@angular/core';
import { OAuthEvent, OAuthService } from 'angular-oauth2-oidc';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment, CustomEnvironment, setApiOverrides } from '../../environments/environment';
import { Observable } from 'rxjs';
import { catchError, map, startWith, tap } from 'rxjs/operators';
import { HttpErrorHandlerService, HandleError } from './http-error-handling.service';
import * as moment from 'moment';
const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Authorization': 'my-auth-token'
  })
};

@Injectable()
export class CollateralService {
  private handleError: HandleError;

  constructor(private oauthService: OAuthService,
    private http: HttpClient,
    httpErrorHandler: HttpErrorHandlerService,
    @Inject(CustomEnvironment) customEnvironment: any) {
    setApiOverrides(customEnvironment);

    this.oauthService.events.subscribe((event: OAuthEvent) => {
      const tokenUpdatedEvents: any = ['token_refreshed', 'token_received', 'silently_refreshed'];
      if (tokenUpdatedEvents.includes(event.type)) {
        httpOptions.headers = httpOptions.headers.set('Authorization', this.oauthService.authorizationHeader());
      }
    });

    httpOptions.headers = httpOptions.headers.set('Authorization', this.oauthService.authorizationHeader());
    this.handleError = httpErrorHandler.createHandleError('CollateralService');
  }

  searchMotorVehicles(searchTerm: string, pageSize: Number, collateralClass?): Observable<any> {
    return this.http.get(`${environment.api.collateral}/motor-vehicles/search?frag=${searchTerm}&n=${pageSize}&class=${collateralClass}`, httpOptions)
    .pipe(
      map( results => {
          return this.addTBACollaterals(results, collateralClass);
      })
    );
  }

  /**
   * ADD TBA Collaterals to search results
   * @param searchResults
   * @param collateralClass
   */
  addTBACollaterals(searchResults, collateralClass = 'car') {
    const yearsAllowed = (collateralClass === 'car') ? 12 : 7;
    const tbaModel = {
      "year": null,
      "make": {
        "code": "TBA",
        "name": "TBA",
        "slug": "TBA"
      },
      "model": {
        "code": "TBA",
        "name": "TBA",
        "slug": "TBA"
      },
      "description": "TBA",
      "slug": "tba"
    }
    const endYear = moment().year();
    const startYear = moment().add(yearsAllowed * -1, 'years').year();

    for (let i = startYear; i <= endYear; i++) {
      const tba = Object.assign({}, tbaModel);
      tba.year = i;
      tba.description = `${i} TBA`;
      tba.slug = `${i}-tba`;
      searchResults.push(tba);
    }

    // console.log(searchResults);
    return searchResults;
  }
}
